/**
 * PageHeader — the shared title + subtitle + optional actions row for a referral screen. Keeps the
 * three screens visually consistent (h1 + slate subtitle), RTL-safe via flex + logical gaps.
 */
import type { ReactNode } from "react";

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, badge, actions }: PageHeaderProps) {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "var(--nv-s-3)",
        flexWrap: "wrap",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--nv-s-1)" }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: "var(--nv-s-3)" }}>
          <h1 style={{ fontSize: "var(--nv-fs-h1)", margin: 0 }}>{title}</h1>
          {badge}
        </div>
        {subtitle && <p style={{ margin: 0, color: "var(--nv-slate)" }}>{subtitle}</p>}
      </div>
      {actions && (
        <div style={{ display: "flex", gap: "var(--nv-s-2)", flexWrap: "wrap" }}>{actions}</div>
      )}
    </header>
  );
}
